import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import axios from 'axios';
import APIURL from '../../common/Config';
import Header from '../header/header';
import Footer from '../footer/footer';
import Select from 'react-select'; 
import "./inquiryform.css";
import toast from 'react-hot-toast';
import { useDispatch } from "react-redux";
import { openAuthModal } from "../../redux/authSlice";

const InquiryForm = () => {
    const { astrologerId } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    // Header details from navigation state or localStorage
    const astroName = location.state?.astrologerName || localStorage.getItem('astrologerName') || 'Astrologer';

    // --- Form States ---
    const [formData, setFormData] = useState({
        firstName: '',
        gender: '',
        dob: '',
        tob: '',
        maritalStatus: '',
        occupation: '',
        query: '',
        country: null, 
        state: null,   
        city: null     
    });

    const [countryData, setCountryData] = useState([]);
    const [stateData, setStateData] = useState([]);
    const [cityData, setCityData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState('new');

    
// useEffect(() => {
//     const token = localStorage.getItem("token");
//     const customerId = localStorage.getItem("customerId");
    
//     console.log("--- Inquiry Form Auth Gate ---");
    
    
//     if (!token || !customerId || customerId === "null") {
//         console.error("DEBUG: No valid session. Redirecting to signup...");
//         localStorage.setItem("redirectAfterLogin", window.location.pathname);
//         navigate('/signup');
//     } else {
//         console.log("DEBUG: Token verified. Loading form data.");
//         fetchCountries();
//     }
// }, [navigate]);

useEffect(() => {
    const token = localStorage.getItem("token");
    const customerId = localStorage.getItem("customerId");
    const isLoggedInStored = localStorage.getItem("isLoggedIn");
    
    console.log("--- Inquiry Form Auth Gate ---");
    console.log("Debug Auth:", { token, customerId, isLoggedInStored });

    // Robust Check: matches Chat.jsx logic
    const isAuthenticated = (token && customerId && customerId !== "null") || 
                          (isLoggedInStored === "true" || isLoggedInStored === true);

    if (!isAuthenticated) {
        console.error("DEBUG: No valid session. Redirecting to signup...");
        localStorage.setItem("redirectAfterLogin", window.location.pathname);
        // navigate('/signup');
        dispatch(openAuthModal('login'));
    } else {
        console.log("DEBUG: Access Granted. Loading form data.");
        fetchCountries();
    }
}, [navigate, dispatch]);

    // --- 2. Dropdown Logic ---
    const fetchCountries = async () => {
        try {
            const res = await axios.get(`${APIURL}/api/country/countryList`);
            const options = res.data.map(item => ({ value: item.id, label: item.country_name }));
            setCountryData(options);
        } catch (err) { console.error("Country Error", err); }
    };

    const handleCountryChange = async (option) => {
        setFormData(prev => ({ ...prev, country: option, state: null, city: null }));
        try {
            const res = await axios.get(`${APIURL}/api/states/${option.value}`);
            const options = res.data.map(item => ({ value: item.state_id, label: item.state_name }));
            setStateData(options);
        } catch (err) { console.error(err); }
    };

    const handleStateChange = async (option) => {
        setFormData(prev => ({ ...prev, state: option, city: null }));
        try {
            const res = await axios.get(`${APIURL}/api/cities/${option.value}`);
            const options = res.data.map(item => ({ value: item.city_id, label: item.city_name }));
            setCityData(options);
        } catch (err) { console.error(err); }
    };

    // --- 3. Previous Request (Autofill) ---
    const handlePreviousRequest = async () => {
        setActiveTab('previous');
        setLoading(true);
        const customerId = localStorage.getItem('customerId');
        try {
            const resp = await axios.get(`${APIURL}/astrochat2026/last-init-message/${customerId}`);
            const data = resp.data.messageData;
            if (data) {
                setFormData({
                    firstName: data.firstName || '',
                    gender: data.gender?.toLowerCase() || '',
                    dob: data.dob || '',
                    tob: data.timeOfBirth || '',
                    maritalStatus: data.mStatus || '',
                    occupation: data.oc || '',
                    query: data.query || '',
                    country: data.country ? { label: data.country, value: data.country } : null,
                    state: data.state ? { label: data.state, value: data.state } : null,
                    city: data.city ? { label: data.city, value: data.city } : null,
                });
            }
        } catch (err) {
            // alert("No previous record found.");
            toast.error("No previous record found.");
            setActiveTab('new');
        } finally { setLoading(false); }
    };

    // --- 4. Final Submission ---
    const handleSubmit = async (e) => {
    e.preventDefault();
    const customerId = localStorage.getItem('customerId');

    const messageObject = {
        firstName: formData.firstName,
        gender: formData.gender,
        dob: formData.dob,
        timeOfBirth: formData.tob,
        mStatus: formData.maritalStatus,
        oc: formData.occupation,
        query: formData.query,
        country: formData.country?.label || '', 
        state: formData.state?.label || '',
        city: formData.city?.label || '',
    };

    const payload = {
        msgCatg: 'INIT', // Native app jaisa INIT category
        astrologerId: parseInt(astrologerId),
        customerId: parseInt(customerId),
        messageSender: 'CUSTOMER',
        messageText: JSON.stringify(messageObject), 
    };

    try {
        setLoading(true);
        const res = await axios.post(`${APIURL}/astrochat2026/sendchatmsg`, payload);
        
        // Agar Admin ne error bheja (Native App logic)
        if (res.data?.messageSender === 'ADMIN') {
            toast.error(res.data.messageText || "Insufficient balance to start chat.");
            return;
        }

        if (res.data && res.data.sessionId) {
            navigate(`/chat/${res.data.sessionId}`, { state: { paramKey: res.data } });
        }
    } catch (err) {
        toast.error("Unable to start session. Check your wallet balance.");
    } finally { setLoading(false); }
};
    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     const customerId = localStorage.getItem('customerId');

  
    //     const messageObject = {
    //         firstName: formData.firstName,
    //         gender: formData.gender,
    //         dob: formData.dob,
    //         timeOfBirth: formData.tob,
    //         mStatus: formData.maritalStatus,
    //         oc: formData.occupation,
    //         query: formData.query,
    //         country: formData.country?.label || '', 
    //         state: formData.state?.label || '',
    //         city: formData.city?.label || '',
    //     };

    //     const payload = {
    //         msgCatg: 'INIT',
    //         astrologerId: parseInt(astrologerId),
    //         customerId: parseInt(customerId),
    //         messageSender: 'CUSTOMER',
    //         messageText: JSON.stringify(messageObject), 
    //     };

    //     try {
    //         setLoading(true);
    //         const res = await axios.post(`${APIURL}/astrochat2026/sendchatmsg`, payload);
    //         if (res.data && res.data.sessionId) {
    //             navigate(`/chat/${res.data.sessionId}`, { state: { paramKey: res.data } });
    //         } else if (res.data?.messageSender === 'ADMIN') {
    //             // alert(res.data.messageText);
    //             toast(res.data.messageText, { icon: 'ℹ️' })
    //         }
    //     } catch (err) {
    //         // alert("Unable to start session. Check your wallet balance.");
    //         toast.error("Unable to start session. Check your wallet balance.");
    //     } finally { setLoading(false); }
    // };

    return (
        <div className="inquiry-page">
            <Header />
            <div className="inquiry-container">
                <div className="inquiry-card">
                    <div className="form-header-box">
                        <h2>Inquiry Details</h2>
                        <p>Consulting with: <strong>{astroName}</strong></p>
                    </div>
                    
                    <div className="tab-buttons">
                        <button type="button" className={activeTab === 'new' ? 'active' : ''} onClick={() => setActiveTab('new')}>New Request</button>
                        <button type="button" className={activeTab === 'previous' ? 'active' : ''} onClick={handlePreviousRequest}>Previous Request</button>
                    </div>

                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label>First Name</label>
                            <input type="text" value={formData.firstName} required placeholder="Enter Name"
                                onChange={(e) => setFormData({...formData, firstName: e.target.value})} />
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label>Gender</label>
                                <select value={formData.gender} required onChange={(e) => setFormData({...formData, gender: e.target.value})}>
                                    <option value="">Select</option>
                                    <option value="male">Male</option>
                                    <option value="female">Female</option>
                                    <option value="other">Other</option>
                                </select>
                            </div>
                            <div className="form-group">
                                <label>Marital Status</label>
                                <select value={formData.maritalStatus} required onChange={(e) => setFormData({...formData, maritalStatus: e.target.value})}>
                                    <option value="">Select</option>
                                    <option value="Single">Single</option>
                                    <option value="Married">Married</option>
                                    <option value="Divorced">Divorced</option>
                                </select>
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label>Date of Birth</label>
                                <input type="date" value={formData.dob} required
                                    onChange={(e) => setFormData({...formData, dob: e.target.value})} />
                            </div>
                            <div className="form-group">
                                <label>Time of Birth</label>
                                <input type="time" value={formData.tob} required
                                    onChange={(e) => setFormData({...formData, tob: e.target.value})} />
                            </div>
                        </div>

                        <div className="form-group">
                            <label>Country</label>
                            <Select options={countryData} value={formData.country} onChange={handleCountryChange} placeholder="Select Country" />
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label>State</label>
                                <Select options={stateData} value={formData.state} onChange={handleStateChange} placeholder="Select State" />
                            </div>
                            <div className="form-group">
                                <label>City</label>
                                <Select options={cityData} value={formData.city} onChange={(opt) => setFormData({...formData, city: opt})} placeholder="Select City" />
                            </div>
                        </div>

                        <div className="form-group">
                            <label>Occupation</label>
                            <input type="text" value={formData.occupation} required placeholder="e.g. Engineer, Student"
                                onChange={(e) => setFormData({...formData, occupation: e.target.value})} />
                        </div>

                        <div className="form-group">
                            <label>Your Query</label>
                            <textarea value={formData.query} rows="3" placeholder="Tell us your problem..."
                                onChange={(e) => setFormData({...formData, query: e.target.value})} />
                        </div>

                        <button type="submit" className="submit-btn" disabled={loading}>
                            {loading ? 'Processing...' : 'PROCEED TO CHAT'}
                        </button>
                    </form>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default InquiryForm;